import { render, staticRenderFns } from "./BuddyMainWidget.vue?vue&type=template&id=37815303&scoped=true"
import script from "./BuddyMainWidget.vue?vue&type=script&lang=ts"
export * from "./BuddyMainWidget.vue?vue&type=script&lang=ts"
import style0 from "./BuddyMainWidget.vue?vue&type=style&index=0&id=37815303&prod&lang=scss"
import style1 from "./BuddyMainWidget.vue?vue&type=style&index=1&id=37815303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37815303",
  null
  
)

export default component.exports